import { Helmet } from "react-helmet-async";
import { labelPluralTitulosSemAcento } from "@/utils/copyTituloBilhete";

export function CadastrarPage() {
    return (
        <>
            <Helmet title={labelPluralTitulosSemAcento()} />
            <h1>Cadastrar</h1>
        </>
    )
}